const VideoShopMoneyFormatFunc = function(cents) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const format = window.video_shop_money_format.moneyFormat
  const formatString = format || window.theme.moneyFormat || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return '0';
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g, 
      '$1' + thousands
    );
    const centsAmount = parts[1] ? (decimal + parts[1]) : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
  }

  return formatString.replace(placeholderRegex, value)
    // 移除末尾是0的小数
    .replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
};

if (!customElements.get('video-shop-list')) {
  class VideoShopList extends HTMLElement {
    constructor() {
      super()
      this.initSplide()

      const onVideoItemClickListener = this.onVideoItemClick.bind(this)
      this.querySelectorAll('.video-shop__item').forEach(item => {
        item.addEventListener('click', onVideoItemClickListener)
      })
    }

    initSplide() {
      const options = {
        pagination: false,
        gap: 16
      }
      if (this.getAttribute('width-type') == 'auto') {
        options.autoWidth = true
      } else {
        options.mediaQuery = 'min'
        options.breakpoints = {
          '1': {
            perPage: 1,
            padding: { right: '80px' }
          },
          '768': {
            perPage: parseInt(this.dataset.columnsTablet),
            padding: { right: 0 }
          },
          '1025': {
            perPage: parseInt(this.dataset.columnsDesktop),
            padding: { right: 0 }
          }
        }
      }
      new Splide(this.querySelector('.splide'), options).mount()
    }

    onVideoItemClick(e) {
      const index = parseInt(e.target.closest('.video-shop__item')?.dataset.index || '0')
      this.parentElement.querySelector('video-shop-products')?.openComponent(index)
    }
  }

  customElements.define('video-shop-list', VideoShopList)
}

if (!customElements.get('video-shop-products')) {
  class VideoShopProducts extends HTMLElement {
    constructor() {
      super()
      this.initSplide()

      // 关闭本组件
      const closeComponentListener = this.closeComponent.bind(this)
      this.querySelectorAll('.video-item .control-close').forEach(item => {
        item.addEventListener('click', closeComponentListener)
      })

      // 视频声音开关
      const onVideoControlVolumnClickListener = this.onVideoControlVolumnClick.bind(this)
      this.querySelectorAll('.video-item .control-volumn').forEach(item => {
        item.addEventListener('click', onVideoControlVolumnClickListener)
      })

      // 产品面板-打开
      const onProductPanelOpenListener = this.openProductPanel.bind(this)
      this.querySelectorAll('.video-item .product--plus-icon').forEach(icon => {
        icon.addEventListener('click', onProductPanelOpenListener)
      })

      // 产品面板-关闭
      this.querySelector('.product-wrapper > .close').addEventListener('click', this.closeProductPanel.bind(this))
    }

    get videos() {
      return Array.from(this.querySelectorAll('.video-wrapper video'))
    }

    initSplide() {
      this.splide = new Splide(this.querySelector('.splide'), {
        direction: 'ttb',
        height: '100%',
        perPage: 1,
        gap: 40,
        pagination: false,
        arrows: false
      }).mount()
      this.splide.on('moved', this.onVideoItemChanged.bind(this))
    }

    onVideoItemChanged(newIndex, prevIndex, destIndex) {
      this.videos.forEach(video => {
        video.pause()
      })
      const item = this.splide.Components.Elements.slides[newIndex]
      item?.querySelector('video')?.play()

      this.changeProductPanelByProductId(item?.getAttribute('product-id'))
    }

    onVideoControlVolumnClick() {
      let muted = this.getAttribute('video-muted')
      this.videos.forEach(video => {
        if (muted == '1') {
          video.muted = false
        } else {
          video.muted = true
        }
      })
      if (muted == '1') {
        this.setAttribute('video-muted', '0')
      } else {
        this.setAttribute('video-muted', '1')
      }
    }

    openProductPanel(e) {
      this.setAttribute('product-open', 'true')
      const productId = e.target.closest('[product-id]')?.getAttribute('product-id')
      if (productId) {
        this.changeProductPanelByProductId(productId)
      }
    }

    closeProductPanel() {
      this.setAttribute('product-open', "false")
    }

    // startPlayIndex从0开始
    openComponent(startPlayIndex) {
      this.removeAttribute('hidden')
      if (startPlayIndex == this.splide.index) {
        this.onVideoItemChanged(startPlayIndex)
      } else {
        this.splide.go(startPlayIndex)
      }
      document.body.classList.add('disabled-scroll')
    }

    closeComponent() {
      this.setAttribute('hidden', '')
      document.body.classList.remove('disabled-scroll')
      this.videos.forEach(video => {
        video.pause()
      })
    }

    changeProductPanelByProductId(productId) {
      this.querySelector('video-shop-product-panel:not([hidden])')?.setAttribute('hidden', '')
      this.querySelector(`video-shop-product-panel[product-id="${productId}"]`)?.removeAttribute('hidden')
    }
  }

  customElements.define('video-shop-products', VideoShopProducts)
}

if (!customElements.get('video-shop-product-panel')) {

  class VideoShopProductPanel extends HTMLElement {
    constructor() {
      super()
      try {
        this.productVariants = JSON.parse(this.querySelector('script[product-json]')?.textContent)
      } catch {
        this.productVariants = []
      }
      this.initSplideImages()

      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items')
      this.messageElement = this.querySelector('.message-box')
      this.salePriceElement = this.querySelector('.sale-price')
      this.comparePriceElement = this.querySelector('.compare-price')

      const onOptionValueClickListener = this.onOptionValueClick.bind(this)
      this.querySelectorAll('.option-clickable').forEach(opt => {
        opt.addEventListener('click', onOptionValueClickListener)
      })

      const onQuantityControlClickListener = this.onQuantityControlClick.bind(this)
      this.querySelectorAll('.variant-quantity .quantity-control').forEach(control => {
        control.addEventListener('click', onQuantityControlClickListener)
      })

      this.querySelector('button.add2cart').addEventListener('click', this.onAdd2CartClick.bind(this))
    }

    connectedCallback() {
      this.updatePriceOnVariantChanged()
    }

    initSplideImages() {
      this.splide = new Splide(this.querySelector('.splide'), {
        perPage: 1,
        padding: { right: '10%' },
        arrows: false,
        gap: 16
      }).mount()
    }

    onOptionValueClick(e) {
      const optValue = e.target.closest('.option-value')
      if (optValue.classList.contains('disabled')) {
        return
      }
      optValue.closest('.option-values').querySelector('.option-value.actived')?.classList.remove('actived')
      optValue.classList.add('actived')
      this.updatePriceOnVariantChanged()

      if (optValue.dataset.imageId) {
        const index = this.querySelector(`.product-medias .splide__slide[data-image-id="${optValue.dataset.imageId}"]`)?.dataset.index
        this.splide.go(parseInt(index))
      }
    }

    getSelectedVariant() {
      const selectedValues = []
      this.querySelectorAll('.option-values .option-value.actived').forEach(val => {
        selectedValues.push(val.dataset.value)
      })
      const valueString = selectedValues.join(',')
      for (const variant of this.productVariants) {
        if (valueString == variant.options.join(',')) {
          return variant
        }
      }
      return null
    }

    /*
      主题中需要在全局有如下设置来定义格式化货币
      theme.settings = {
        moneyFormat: {{ shop.money_format | json }}
      }
    */
    updatePriceOnVariantChanged() {
      this.querySelectorAll('.option-values .option-value.actived').forEach(val => {
        const selectedOption = val.closest('.variant-option')?.querySelector('.option-name .selected-option')
        if (selectedOption) {
          selectedOption.textContent = val.dataset.value
        }
      })
      const matchedVariant = this.getSelectedVariant()
      if (matchedVariant) {
        this.salePriceElement.innerHTML = VideoShopMoneyFormatFunc(matchedVariant.price)
        if (matchedVariant.compare_at_price > matchedVariant.price) {
          this.comparePriceElement.innerHTML = VideoShopMoneyFormatFunc(matchedVariant.compare_at_price)
        } else {
          this.comparePriceElement.innerHTML = ''
        }
      }
    }

    onQuantityControlClick(e) {
      const control = e.target.closest('.quantity-control')
      let q = -1
      if (control.classList.contains('plus')) {
        q = 1
      }
      const input = this.querySelector('.variant-quantity input')
      input.value = Math.max(1, parseInt(input.value) + q)
    }

    onAdd2CartClick() {
      const selectedVariant = this.getSelectedVariant()
      if (!selectedVariant) {
        this.showMessage('Please select a variant.')
        return
      }
      const btn = this.querySelector('button.add2cart')
      btn.setAttribute('disabled', '')
      btn.classList.add('loading')

      let formData = {
        items: [
          {
            id: selectedVariant.id,
            quantity: parseInt(this.querySelector('.variant-quantity input').value || '1')
          }
        ],
        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async (response) => {
        this.showMessage(response.ok)
        if (response.ok) {
          btn.classList.add('added')
          const cartData = await response.json()
          if (this.cart) {
            this.cart.renderContents(cartData, false)
          }
        }
      })
      .catch((error) => {
        console.log(error)
        this.showMessage(false)
      })
      .finally(() => {
        btn.removeAttribute('disabled')
        btn.classList.remove('loading')
      })
    }

    /**
     * 更新购物车图标旁的数量信息，购物车图标数量的元素和主题模板有关，需要针对模板进行调整
     * @param {number} total 
     */
    updateCartTotal(total) {
      const cartCountElement = document.querySelector('header .cart-count-bubble span:first-of-type')
      if (cartCountElement) {
        cartCountElement.textContent = total
      }
    }

    /**
     * @param {boolean | string} type true表示成功消息，false表示失败消息，字符串表示具体的失败描述 
     */
    showMessage(type) {
      let msg = type
      if (typeof type == 'string') {
        type = false
      } else {
        msg = type ? 
        'The product has been added to your shopping cart.' : 
        'Adding to cart failed, please try again.'
      }
      this.messageElement.textContent = msg
      this.messageElement.setAttribute('type', type ? 'success' : 'error')
      this.messageElement.setAttribute('open', '')
      setTimeout(() => {
        this.messageElement.removeAttribute('open')
      }, 3000)
    }
  }

  customElements.define('video-shop-product-panel', VideoShopProductPanel)
}